import { openGdprManager } from '../util/gdpr_consent'

up.compiler(
  '[data-open-gdpr-manager]',
  (element: HTMLElement, { openGdprManager: privacyManagerId }: { openGdprManager: string }) => {
    up.on(element, 'click', () => {
      openGdprManager(privacyManagerId)
    })
  },
)
